// @ts-nocheck
import React from "react";
import { compose } from "../../core";
import { withApollo } from '@apollo/client/react/hoc';
import BarsDefineView from "../Components/BarsDefineView";
import { ALL_COMPETENCY_CATEGORIES } from "../graphql/DefineBarsQueries.gql";
import { Row, Spin } from "antd";
import NoPermissionView from "modules/kudos-user/component/NoPermissionComponent";
import { globalPermissionValidator } from "modules/look";
import { bars_permission } from "Permissions/bars.permission";

const BarsDefineContainer = (props) => {
    const { client, me, permissionLoader, userPermission } = props;
    const [CompetenyCaetgoriesLoading, setCompetencyCategoryLoading] = React.useState(false)
    const [competencyCategories, setCompetencyCategories] = React.useState(undefined);
    const [barsPermission, setBarsPermission] = React.useState(undefined);
    const [barsPermissionLoading, setBarsPermissionLoading] = React.useState(true);

    React.useEffect(() => {
        // based on permission of user bars will be di
        if (barsPermission?.required_permission && barsPermission?.define_bars_permission) {
            getCompetencies({ organization: me?.employee?.organizationSet?.edges[0]?.node?.id });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [barsPermission])

    React.useEffect(() => {
        if (userPermission?.length) {
            let permission = globalPermissionValidator(bars_permission, userPermission);
            setBarsPermission(permission)
            setBarsPermissionLoading(false)
        }
    }, [userPermission])

    const getCompetencies = async (filter) => {
        setCompetencyCategoryLoading(true)
        const { data } = await client.query({
            query: ALL_COMPETENCY_CATEGORIES,
            fetchPolicy: 'network-only',
            variables: { ...filter }
        });
        if (data?.allCompetencyCategory) {
            let filteredList = data?.allCompetencyCategory?.edges?.filter((value) => !value?.node?.behaviourallyanchoredratingSet?.totalCount)
            let list = filteredList.map(({ node }) => {
                return {
                    ...node
                }
            })
            setCompetencyCategories(list)
            setCompetencyCategoryLoading(false)
        }
    }

    return (
        <>
            <Row justify='center' align='middle'>
                {
                    <Spin spinning={permissionLoader || barsPermissionLoading} wrapperClassName='permission-check-bars'>
                        {
                            barsPermission && barsPermission.define_bars_permission
                                ? <div>
                                    {
                                        barsPermission !== undefined &&
                                        <div>
                                            {
                                                barsPermission?.required_permission ?
                                                    <BarsDefineView
                                                        CompetenyCaetgoriesLoading={CompetenyCaetgoriesLoading}
                                                        competencyCategories={competencyCategories}
                                                        {...props}
                                                    />
                                                    :
                                                    <NoPermissionView />
                                            }

                                        </div>
                                    }
                                </div>
                                : !barsPermission
                                    ? ""
                                    : <NoPermissionView />
                        }
                    </Spin>
                }
            </Row>
        </>
    );
};

export default compose(withApollo)(BarsDefineContainer);
